import {HttpServices} from '../Helpers';

export const GetVerifiedDevices = async () => {
  const result = await HttpServices.get(
    `${process.env.REACT_APP_MFA_API}/user/devices/verified-devices`,
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const VerifyUserDevice = async ({email, recaptcha}) => {
  const result = await HttpServices.post(
    `${process.env.REACT_APP_MFA_API}/user/devices/verify`,
    {
      email,
      recaptcha,
    },
    {
      headers: {
        isPublic: true,
      },
    },
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const DeleteVerifiedDevices = async (body) => {
  const result = await HttpServices.delete(
    `${process.env.REACT_APP_MFA_API}/user/devices/remove-device`,
    {
      data: body,
    },
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

